import React from 'react';

function StyleBuilder({ styleConfig, setStyleConfig }) {

  // For top-level state items (primary, secondary)
  const handleColorChange = (key, value) => {
    setStyleConfig(prev => ({ ...prev, [key]: value }));
  };

  // For nested state items (body, header, footer, etc.)
  const handleNestedChange = (section, key, value) => {
    setStyleConfig(prev => ({
      ...prev,
      [section]: { ...prev[section], [key]: value }
    }));
  };

  return (
    <div className="accordion" id="styleBuilderAccordion">
      
      {/* 1. Global Colors */}
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#globalColors">
            Global Colors
          </button>
        </h2>
        <div id="globalColors" className="accordion-collapse collapse show">
          <div className="accordion-body">
            <label className="form-label">Primary Color</label>
            <input 
              type="color" 
              className="form-control form-control-color w-100" 
              value={styleConfig.primary} 
              onChange={e => handleColorChange('primary', e.target.value)} 
            />
            
            <label className="form-label mt-2">Secondary Color</label>
            <input 
              type="color" 
              className="form-control form-control-color w-100" 
              value={styleConfig.secondary} 
              onChange={e => handleColorChange('secondary', e.target.value)} 
            />
          </div>
        </div>
      </div>

      {/* 2. Body / Page Styles */}
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#bodyStyles">
            Body & Typography
          </button>
        </h2>
        <div id="bodyStyles" className="accordion-collapse collapse">
          <div className="accordion-body">
            <label className="form-label">Page Background Color</label>
            <input 
              type="color" 
              className="form-control form-control-color w-100" 
              value={styleConfig.body?.bgColor || "#ffffff"} 
              onChange={e => handleNestedChange('body', 'bgColor', e.target.value)} 
            />
            
            <label className="form-label mt-2">Default Text Color</label>
            <input 
              type="color" 
              className="form-control form-control-color w-100" 
              value={styleConfig.body?.textColor || "#333333"} 
              onChange={e => handleNestedChange('body', 'textColor', e.target.value)} 
            />
            
            <label className="form-label mt-2">Global Font</label>
            <select 
              className="form-select" 
              value={styleConfig.body?.fontFamily || "'Inter', sans-serif"} 
              onChange={e => handleNestedChange('body', 'fontFamily', e.target.value)}
            >
              <option value="'Inter', sans-serif">Inter</option>
              <option value="'Poppins', sans-serif">Poppins</option>
              <option value="'Roboto', sans-serif">Roboto</option>
              <option value="'Playfair Display', serif">Playfair Display</option>
              <option value="'Montserrat', sans-serif">Montserrat</option>
            </select>
          </div>
        </div>
      </div>

      {/* 3. Top Bar */}
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#topbar">
            Top Bar
          </button>
        </h2>
        <div id="topbar" className="accordion-collapse collapse">
          <div className="accordion-body">
            <label className="form-label">Background Color</label>
            <input 
              type="color" 
              className="form-control form-control-color w-100" 
              value={styleConfig.topBar?.bgColor || "#f8f9fa"} 
              onChange={e => handleNestedChange('topBar', 'bgColor', e.target.value)} 
            />
            
            <label className="form-label mt-2">Text Color</label>
            <input 
              type="color" 
              className="form-control form-control-color w-100" 
              value={styleConfig.topBar?.textColor || "#212529"} 
              onChange={e => handleNestedChange('topBar', 'textColor', e.target.value)} 
            />
          </div>
        </div>
      </div>

      {/* 4. Header */}
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#headerStyle">
            Header
          </button>
        </h2>
        <div id="headerStyle" className="accordion-collapse collapse">
          <div className="accordion-body">
            <label className="form-label">Background Color</label>
            <input 
              type="color" 
              className="form-control form-control-color w-100" 
              value={styleConfig.header?.bgColor || "#007bff"} 
              onChange={e => handleNestedChange('header', 'bgColor', e.target.value)} 
            />
            
            <label className="form-label mt-2">Text Color</label>
            <input 
              type="color" 
              className="form-control form-control-color w-100" 
              value={styleConfig.header?.textColor || "#ffffff"} 
              onChange={e => handleNestedChange('header', 'textColor', e.target.value)} 
            />
          </div>
        </div>
      </div>

      {/* 5. Hero Section */}
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#heroStyle">
            Hero Section
          </button>
        </h2>
        <div id="heroStyle" className="accordion-collapse collapse">
          <div className="accordion-body">
            <label className="form-label">Subtitle Text Color</label>
            <input 
              type="color" 
              className="form-control form-control-color w-100" 
              value={styleConfig.hero?.subtitleColor || "#e9ecef"} 
              onChange={e => handleNestedChange('hero', 'subtitleColor', e.target.value)} 
            />
            
            <label className="form-label mt-2">Overlay Darken Color</label>
            <input 
              type="color" 
              className="form-control form-control-color w-100" 
              value={styleConfig.hero?.overlayColor || "#000000"} 
              onChange={e => handleNestedChange('hero', 'overlayColor', e.target.value)} 
            />
          </div>
        </div>
      </div>

      {/* 6. Footer */}
      <div className="accordion-item">
        <h2 className="accordion-header">
          <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#footerStyle">
            Footer
          </button>
        </h2>
        <div id="footerStyle" className="accordion-collapse collapse">
          <div className="accordion-body">
            <label className="form-label">Background Color</label>
            <input 
              type="color" 
              className="form-control form-control-color w-100" 
              value={styleConfig.footer?.bgColor || "#2c3e50"} 
              onChange={e => handleNestedChange('footer', 'bgColor', e.target.value)} 
            />
            
            <label className="form-label mt-2">Text Color</label>
            <input 
              type="color" 
              className="form-control form-control-color w-100" 
              value={styleConfig.footer?.textColor || "#ecf0f1"} 
              onChange={e => handleNestedChange('footer', 'textColor', e.target.value)} 
            />
            
            <label className="form-label mt-2">Link Color</label>
            <input 
              type="color" 
              className="form-control form-control-color w-100" 
              value={styleConfig.footer?.linkColor || "#bdc3c7"} 
              onChange={e => handleNestedChange('footer', 'linkColor', e.target.value)} 
            />
          </div>
        </div>
      </div>

    </div>
  );
}

export default StyleBuilder;